// extracted by mini-css-extract-plugin
module.exports = {"modalBox":"pop_modalBox_2dP5N","msgList":"pop_msgList_uZ5jT","msgItem":"pop_msgItem_26haf","label":"pop_label_3m2nx","value":"pop_value_1bsjv"};